import styled from 'styled-components';

export const TestimonialBackgroundWrapper = styled.div`
  background-image: url('https://via.placeholder.com/1500');
  background-size: cover;
  background-position: center;
`;

export const GraySectionWrapper = styled.div`
  background-color: ${props => props.theme.colors.neutrals['white-darker']};
`;

export const BlueSectionWrapper = styled.div`
  background-image: url('/static/program-banner-blue.jpg');
  padding: 0 calc((100vw - 1280px) / 2);
`;

export const GreenSectionWrapper = styled.div`
  background-color: #d9e8e7;
`;

export const WhiteSectionWrapper = styled.div`
  background-color: ${props => props.theme.colors.neutrals['white']};
`;
